import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";


const Protected = () => {
    const { isLoggedIn } = useSelector(state => state.auth);
    return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default Protected;